<template>
  <div>
    <a-page-header style="width: 105%; margin-left: -20px">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="pie-chart"></a-icon>
            <span>{{ $t("message.customGroup.title1") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="team"></a-icon>
            <span>{{ $t("message.userAnalysis.audienceDashboard") }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <div class="page-title">{{ $t("message.userAnalysis.audienceDashboard") }}</div>
    <div>
      <a-spin :spinning="spinning">
        <div style="height: 24px"></div>
        <a-tabs v-model="tabSelected" default-active-key="group_tab1" @change="tableChg">
          <a-tab-pane
            key="group_tab1"
            :tab="$t('message.userAnalysis.membershipAttributes')"
          >
            <div>
              <a-card class="card-container">
                <!-- 查询 -->
                <a-row class="mb30">
                  <a-form-model layout="inline">
                    <a-form-model-item :label="$t('message.userAnalysis.selectAudience')">
                      <a-select :size="$globalSize"
                        v-model="people1"
                        show-search
                        placeholder="Select a person"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        style="width: 400px"
                        @change="forceUpdate"
                        @select="peopleChgAdd"
                      >
                        <a-select-option value="all" :title="$t('message.userAnalysis.all')"> {{$t('message.userAnalysis.all')}} </a-select-option>
                        <a-select-option
                          v-for="(item, index) in peopleList"
                          :key="index"
                          :value="item.group_id"
                          :title="item.group_id"
                        >
                          {{ item.group_name }} ({{ item.group_id }})
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-form-model>
                </a-row>
                <a-row class="mb30 height200" type="flex" justify="center" align="top">
                  <!-- 会员人数 -->
                  <a-col :span="8">
                    <div class="height200 member-container">
                      <div class="icon-container">
                        <svg
                          t="1610591379247"
                          class="member-logo-svg"
                          viewBox="0 0 1280 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="1126"
                          width="40"
                          height="40"
                        >
                          <path
                            d="M192 448c70.6 0 128-57.4 128-128s-57.4-128-128-128-128 57.4-128 128 57.4 128 128 128z m896 0c70.6 0 128-57.4 128-128s-57.4-128-128-128-128 57.4-128 128 57.4 128 128 128z m64 64h-128c-35.2 0-67 14.2-90.2 37.2 80.6 44.2 137.8 124 150.2 218.8h132c35.4 0 64-28.6 64-64v-64c0-70.6-57.4-128-128-128z m-512 0c123.8 0 224-100.2 224-224S763.8 64 640 64 416 164.2 416 288s100.2 224 224 224z m153.6 64h-16.6c-41.6 20-87.8 32-137 32s-95.2-12-137-32h-16.6C359.2 576 256 679.2 256 806.4V864c0 53 43 96 96 96h576c53 0 96-43 96-96v-57.6c0-127.2-103.2-230.4-230.4-230.4z m-447.4-26.8C323 526.2 291.2 512 256 512H128c-70.6 0-128 57.4-128 128v64c0 35.4 28.6 64 64 64h131.8c12.6-94.8 69.8-174.6 150.4-218.8z"
                            p-id="1127"
                          ></path>
                        </svg>
                      </div>
                      <div class="num-container">
                        <div class="num">
                          <a-statistic :value="memberProperties.membersNumber" /> &nbsp;{{
                            $t("message.userGroupDetail.people")
                          }}
                        </div>
                        <div class="title">
                          {{ $t("message.userAnalysis.totalMembershipCount") }}
                        </div>
                      </div>
                    </div>
                  </a-col>
                  <!--  会员分类  -->
                  <a-col :span="16">
                    <div class="ml18 height200 border-container">
                      <div class="common-title">
                        {{ $t("message.userAnalysis.membershipClassification") }}
                      </div>
                      <a-divider class="divider-container" />
                      <div class="common-content">
                        <a-row>
                          <a-col :span="6">
                            <ProgressCharts
                              :percent="
                                memberProperties.memberClassification.is_member.percent
                              "
                              :strokeColor="strokeColor"
                              :titleName="$t('message.userAnalysis.regularMembers')"
                            />
                          </a-col>
                          <a-col :span="6">
                            <ProgressCharts
                              :percent="
                                memberProperties.memberClassification.is_omc_member
                                  .percent
                              "
                              :strokeColor="strokeColor"
                              :titleName="$t('message.userAnalysis.OHMembers')"
                            />
                          </a-col>
                          <a-col :span="6">
                            <ProgressCharts
                              :percent="
                                memberProperties.memberClassification.m_breakfast_card_30d
                                  .percent
                              "
                              :strokeColor="strokeColor"
                              :titleName="$t('message.userAnalysis.breakfastCardMembers')"
                            />
                          </a-col>
                          <a-col :span="6">
                            <ProgressCharts
                              :percent="
                                memberProperties.memberClassification.is_mccafe_member
                                  .percent
                              "
                              :strokeColor="strokeColor"
                              :titleName="$t('message.userAnalysis.McCafeMembers')"
                            />
                          </a-col>
                        </a-row>
                      </div>
                    </div>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="24">
                    <a-col :span="12">
                      <div class="height320 border-container mr14">
                        <div class="common-title">{{$t('message.userAnalysis.membershipStatus')}}</div>
                        <a-divider class="divider-container" />
                        <div
                          class="common-content"
                          id="MemberStatus"
                          style="height: 220px"
                        ></div>
                      </div>
                    </a-col>
                    <a-col :span="12">
                      <div class="height320 border-container ml14">
                        <div class="common-title">{{$t('message.userAnalysis.registrationChannel')}}</div>
                        <a-divider class="divider-container" />
                        <div
                          class="common-content"
                          id="RegisterChannel"
                          style="height: 220px"
                        ></div>
                      </div>
                    </a-col>
                  </a-col>
                </a-row>
              </a-card>
            </div>
          </a-tab-pane>
          <a-tab-pane
            key="group_tab2"
            :tab="$t('message.userAnalysis.consumptionBehaviorPreferenceAttr')"
          >
            <a-card class="card-container">
              <a-spin :spinning="spinningChartsInfoPage2">
                <!-- 查询 -->
                <a-row class="mb30">
                  <a-form-model layout="inline">
                    <a-form-model-item :label="$t('message.userAnalysis.selectAudience')">
                      <a-select :size="$globalSize"
                        v-model="people2"
                        show-search
                        placeholder="Select a person"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        style="width: 400px"
                        @change="peopleChgAdd"
                      >
                        <a-select-option value="all" :title="$t('message.userAnalysis.all')"> {{ $t('message.userAnalysis.all') }} </a-select-option>
                        <a-select-option
                          v-for="(item, index) in peopleList"
                          :key="index"
                          :value="item.group_id"
                          :title="item.group_id"
                        >
                          {{ item.group_name }} ({{ item.group_id }})
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-form-model>
                </a-row>
                <a-row class="mb30">
                  <a-col :span="8">
                    <div class="mr14 height320 border-container">
                      <div class="common-title">{{ $t('message.userAnalysis.Proportion') }}</div>
                      <a-divider class="divider-container" />
                      <div
                        class="common-content"
                        id="ActiveNumberChannels"
                        style="height: 250px"
                      ></div>
                    </div>
                  </a-col>
                  <a-col :span="8">
                    <div class="ml7 mr7 height320 border-container">
                      <div class="common-title">{{ $t('message.userAnalysis.City') }}</div>
                      <div class="city-title">{{ $t('message.userAnalysis.CityRanking') }}</div>
                      <a-divider class="city-divider-container" />
                      <div
                        class="common-content"
                        id="MostConsumedMarket"
                        style="height: 250px"
                      ></div>
                    </div>
                  </a-col>
                  <a-col :span="8">
                    <div class="ml14 height320 border-container">
                      <div class="common-title user-analysis-radio">
                        {{ $t('message.userAnalysis.PurchasePeriod') }}
                        <a-radio-group :size="$globalSize"
                          button-style="solid"
                          v-model="purchaseType"
                          @change="onChangePurchase"
                          
                          style="float: right"
                        >
                          <a-radio-button value="a">{{ $t('message.userAnalysis.Cycle') }}</a-radio-button>
                          <a-radio-button value="b">{{ $t('message.userAnalysis.TimePoint') }}</a-radio-button>
                        </a-radio-group>
                      </div>
                      <a-divider class="divider-container" />
                      <div
                        class="common-content"
                        id="PurchaseTimePreference"
                        style="height: 250px"
                      ></div>
                    </div>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="8">
                    <div class="mr14 height320 border-container">
                      <div class="common-title">{{ $t('message.userAnalysis.Ingredients') }}</div>
                      <a-divider class="divider-container" />
                      <div
                        class="common-content"
                        id="ProductIngredients"
                        style="height: 220px"
                      ></div>
                    </div>
                  </a-col>
                  <a-col :span="8">
                    <div class="ml7 mr7 height320 border-container">
                      <div class="common-title">{{ $t('message.userAnalysis.Taste') }}</div>
                      <a-divider class="divider-container" />
                      <div
                        class="common-content"
                        id="ProductTaste"
                        style="height: 220px"
                      ></div>
                    </div>
                  </a-col>
                  <a-col :span="8">
                    <div class="ml14 height320 border-container">
                      <div class="common-title">{{ $t('message.userAnalysis.CookingMethod') }}</div>
                      <a-divider class="divider-container" />
                      <div
                        class="common-content"
                        id="ProductCooked"
                        style="height: 220px"
                      ></div>
                    </div>
                  </a-col>
                </a-row>
              </a-spin>
            </a-card>
          </a-tab-pane>
          <a-tab-pane
            key="group_tab3"
            :tab="$t('message.userAnalysis.consumptionBehaviorDataAttr')"
          >
            <a-card class="card-container">
              <a-spin :spinning="spinningChartsInfoPage2">
                <!-- 查询 -->
                <a-row class="mb30">
                  <a-form-model layout="inline">
                    <a-form-model-item :label="$t('message.userAnalysis.selectAudience')">
                      <a-select :size="$globalSize"
                        v-model="people3"
                        show-search
                        placeholder="Select a person"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        style="width: 400px"
                        @change="peopleChgAdd"
                      >
                        <a-select-option value="all" :title="$t('message.userAnalysis.all')"> {{ $t('message.userAnalysis.all') }} </a-select-option>
                        <a-select-option
                          v-for="(item, index) in peopleList"
                          :key="index"
                          :value="item.group_id"
                          :title="item.group_id"
                        >
                          {{ item.group_name }} ({{ item.group_id }})
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-form-model>
                </a-row>
                <a-row class="mb30">
                  <a-col :span="8">
                    <div class="mr14 height320 border-container">
                      <div class="common-title">Sales</div>
                      <a-divider class="divider-container-nobottom" />
                      <div class="common-content" id="Sales" style="height: 240px"></div>
                    </div>
                  </a-col>
                  <a-col :span="8">
                    <div class="ml7 mr7 height320 border-container">
                      <div class="common-title">GC</div>
                      <a-divider class="divider-container-nobottom" />
                      <div class="common-content" id="GC" style="height: 240px"></div>
                    </div>
                  </a-col>
                  <a-col :span="8">
                    <div class="ml14 height320 border-container">
                      <div class="common-title">AC</div>
                      <a-divider class="divider-container-nobottom" />
                      <div class="common-content" id="AC" style="height: 240px"></div>
                    </div>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="8">
                    <div class="mr14 height320 border-container">
                      <div class="common-title">
                        {{ $t('message.userAnalysis.DaysSinceLastOrder') }}
                        <div class="statistics-container">
                          <div class="statistics-num">
                            {{ ConsumerBbehaviorData.LastOrderDays.avg }} {{ $t('message.userAnalysis.Days') }}
                          </div>
                          <div class="statistics-title">{{ $t('message.userAnalysis.AvgDaysperPerson') }}</div>
                        </div>
                      </div>
                      <a-divider class="city-divider-container" />
                      <div
                        class="common-content"
                        id="LastOrderDays"
                        style="height: 220px"
                      ></div>
                    </div>
                  </a-col>
                  <a-col :span="8">
                    <div class="ml7 mr7 height320 border-container">
                      <div class="common-title">
                        {{ $t('message.userAnalysis.FreqStats') }}
                        <div class="statistics-container">
                          <div class="statistics-num">
                            {{ ConsumerBbehaviorData.ConsumptionFrequency.avg }} {{ $t('message.userAnalysis.Times') }}
                          </div>
                          <div class="statistics-title">{{ $t('message.userAnalysis.AvgFreqperPerson') }}</div>
                        </div>
                      </div>
                      <a-divider class="city-divider-container" />
                      <div
                        class="common-content"
                        id="ConsumptionFrequency"
                        style="height: 220px"
                      ></div>
                    </div>
                  </a-col>
                </a-row>
              </a-spin>
            </a-card>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </div>
  </div>
</template>

<script>
import userAnalysis from "@/interface/pages/UserGroup/userAnalysis";
import util from "@/utils.js";
import {
  HistogramCharts,
  draggableHistogramCharts,
  RingPieCharts,
  HorizontalHistogramTop4,
  AreaLineChart,
  ColumnLineChart,
} from "@/utils/charts.js";
import ProgressCharts from "./conponents/ProgressCharts.vue";
import { strokeColor } from "@/utils/theme";
export default {
  name: "UserGroupAnalysis",
  data() {
    return {
      strokeColor,
      memberProperties: {
        membersNumber: 0,
        memberClassification: {
          is_mccafe_member: { percent: 0 },
          is_omc_member: { percent: 0 },
          is_member: { percent: 0 },
          m_breakfast_card_30d: { percent: 0 },
        },
        memberstatus: {},
        registerChannel: {},
      },
      purchasePreferenceData: {
        ActiveNumber: [],
        top4data: [],
        purchaseTypeCycle: {},
        purchaseTypeCyclePoint: {},
        ProductIngredients: { data: [], legend: [] },
        ProductTaste: { data: [], legend: [] },
        ProductCooked: { data: [], legend: [] },
      },
      ConsumerBbehaviorData: {
        SalesData: { dataPercent: [], dataValue: [], legend: [] },
        GCData: { dataPercent: [], dataValue: [], legend: [] },
        ACData: { dataPercent: [], dataValue: [], legend: [] },
        LastOrderDays: { data: [], legend: [], avg: 0 },
        ConsumptionFrequency: { data: [], legend: [], avg: 0 },
      },
      purchaseType: "a",
      spinning: false,
      tabSelected: "group_tab1",
      people1: "all",
      people2: "all",
      people3: "all",
      peopleList: [],
      spinningChartsInfo: false,
      spinningChartsInfoPage2: false,
      spinningCharts: false,
      user_list_group_id: "",
    };
  },
  components: {
    ProgressCharts,
  },
  created() {
    this.getOptionData();
  },
  methods: {
    queryCharsById(groupId) {
      let param = {
        group_id: groupId,
        tab: this.tabSelected,
      };
      userAnalysis
        .queryCharsById(this, { params: param })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              let data = res.data;
              if (this.tabSelected === "group_tab1") {
                this.memberProperties.membersNumber = res.obj || 0;
                if (data.length === 0) {
                  this.emptyMemberProperties();
                } else {
                  data.forEach((item) => {
                    let chart_name = item.chart_name;
                    let chart_json = item.chart_json;
                    switch (chart_name) {
                      case "member_type":
                        this.memberProperties.memberClassification =
                          chart_json[chart_name];
                        break;
                      case "register_channel":
                        this.memberProperties.registerChannel = chart_json[chart_name];
                        break;
                      case "m_member_property_90d_all_type":
                        this.memberProperties.memberstatus = chart_json[chart_name];
                        break;
                    }
                  });
                }
              } else if (this.tabSelected === "group_tab2") {
                if (data.length > 0) {
                  data.forEach((item) => {
                    let chart_name = item.chart_name;
                    let chart_json = item.chart_json;
                    switch (chart_name) {
                      case "active_be_type":
                        this.purchasePreferenceData.ActiveNumber =
                          chart_json[chart_name].data;
                        break;
                      case "m_most_city":
                        let m_most_city_data = chart_json[chart_name].data;
                        m_most_city_data.sort((a, b) => b.value - a.value);
                        let new_m_most_city_data = m_most_city_data.slice(0, 4);
                        this.purchasePreferenceData.top4data = new_m_most_city_data;
                        break;
                      case "prefer_day_tag":
                        this.purchasePreferenceData.purchaseTypeCycle =
                          chart_json[chart_name].data;
                        break;
                      case "prefer_daypart":
                        this.purchasePreferenceData.purchaseTypeCyclePoint =
                          chart_json[chart_name].data;
                        break;
                      case "protein_prefer":
                        this.purchasePreferenceData.ProductIngredients =
                          chart_json[chart_name];
                        break;
                      case "taste_prefer":
                        this.purchasePreferenceData.ProductTaste = chart_json[chart_name];
                        break;
                      case "cook_prefer":
                        this.purchasePreferenceData.ProductCooked =
                          chart_json[chart_name];
                        break;
                    }
                  });
                  this.initCharts();
                } else {
                  this.emptyBehaviorPreference();
                }
              } else if (this.tabSelected === "group_tab3") {
                if (data.length > 0) {
                  data.forEach((item) => {
                    let chart_name = item.chart_name;
                    let chart_json = item.chart_json;
                    switch (chart_name) {
                      case "sales":
                        this.ConsumerBbehaviorData.SalesData = chart_json[chart_name];
                        break;
                      case "gc":
                        this.ConsumerBbehaviorData.GCData = chart_json[chart_name];
                        break;
                      case "ac":
                        this.ConsumerBbehaviorData.ACData = chart_json[chart_name];
                        break;
                      case "m_last_order_time_today":
                        this.ConsumerBbehaviorData.LastOrderDays = chart_json[chart_name];
                        break;
                      case "m_order_cnt":
                        this.ConsumerBbehaviorData.ConsumptionFrequency =
                          chart_json[chart_name];
                        break;
                    }
                  });
                } else {
                  this.emptyConsumerBehaviorAttributes();
                }
              }
            } else {
              this.$message.error(res.message);
            }
            this.initCharts();
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
        });
    },
    emptyMemberProperties() {
      this.memberProperties.memberClassification = {
        is_mccafe_member: { percent: 0 },
        is_omc_member: { percent: 0 },
        is_member: { percent: 0 },
        m_breakfast_card_30d: { percent: 0 },
      };
      this.memberProperties.memberstatus = {
        data: [],
        legend: [],
      };
      this.memberProperties.registerChannel = { data: [], legend: [] };
    },
    emptyBehaviorPreference() {
      this.purchasePreferenceData.ActiveNumber = [];
      this.purchasePreferenceData.top4data = [];
      this.purchasePreferenceData.purchaseTypeCycle = [];
      this.purchasePreferenceData.purchaseTypeCyclePoint = [];
      let emptyData = { data: [] };
      this.purchasePreferenceData.ProductIngredients = emptyData;
      this.purchasePreferenceData.ProductTaste = emptyData;
      this.purchasePreferenceData.ProductCooked = emptyData;
    },
    emptyConsumerBehaviorAttributes() {
      let emptyData1 = { dataPercent: [], dataValue: [], legend: [] };
      this.ConsumerBbehaviorData.SalesData = emptyData1;
      this.ConsumerBbehaviorData.GCData = emptyData1;
      this.ConsumerBbehaviorData.ACData = emptyData1;
      let emptyData = { avg: 0, data: [], legend: [] };
      this.ConsumerBbehaviorData.LastOrderDays = emptyData;
      this.ConsumerBbehaviorData.ConsumptionFrequency = emptyData;
    },
    initCharts() {
      if (this.tabSelected === "group_tab1") {
        this.$nextTick(() => {
          HistogramCharts("MemberStatus", this.memberProperties.memberstatus);
          // draggableHistogramCharts('RegisterChannel', this.memberProperties.memberstatus);
          draggableHistogramCharts(
            "RegisterChannel",
            this.memberProperties.registerChannel,
            false,
            3
          );
        });
      } else if (this.tabSelected === "group_tab2") {
        this.$nextTick(() => {
          RingPieCharts("ActiveNumberChannels", this.purchasePreferenceData.ActiveNumber);
          HorizontalHistogramTop4(
            "MostConsumedMarket",
            this.purchasePreferenceData.top4data
          );
          this.purchaseHandle(this.purchaseType);
          draggableHistogramCharts(
            "ProductIngredients",
            this.purchasePreferenceData.ProductIngredients
          );
          HistogramCharts("ProductTaste", this.purchasePreferenceData.ProductTaste);
          HistogramCharts("ProductCooked", this.purchasePreferenceData.ProductCooked);
        });
      } else if (this.tabSelected === "group_tab3") {
        this.$nextTick(() => {
          ColumnLineChart("Sales", this.ConsumerBbehaviorData.SalesData, [
            "Sales",
            "WOW",
          ]);
          ColumnLineChart("GC", this.ConsumerBbehaviorData.GCData, ["GC", "WOW"]);
          ColumnLineChart("AC", this.ConsumerBbehaviorData.ACData, ["AC", "WOW"]);
          draggableHistogramCharts(
            "LastOrderDays",
            this.ConsumerBbehaviorData.LastOrderDays
          );
          draggableHistogramCharts(
            "ConsumptionFrequency",
            this.ConsumerBbehaviorData.ConsumptionFrequency
          );
        });
      }
    },
    search() {
      this.spinning = true;
      this.$nextTick(() => {
        // HistogramCharts('MemberStatus', data)
      });
      this.spinning = false;
    },
    changePeopleConsuming() {},
    changePeopleConsumption() {},
    tableChg(key) {
      if (key === "group_tab1") {
        this.queryCharsById(this.people1);
      } else if (key === "group_tab2") {
        this.purchaseType = "a";
        this.queryCharsById(this.people2);
      } else if (key === "group_tab3") {
        this.queryCharsById(this.people3);
      }
    },
    getOptionData() {
      userAnalysis
        .getOption(this, { params: {} })
        .then(
          function (resp) {
            let res = resp.data;
            if (res.code == "200") {
              this.peopleList = res.data;
              let query = this.$route.query;
              if (Object.keys(query).length == 0) {
              } else {
                this.user_list_group_id = query.group_id;
                this.people1 = this.people2 = this.people3 = this.user_list_group_id;
              }
              this.$nextTick(() => {
                this.forceUpdate();
                this.queryCharsById(this.people1);
              });
            }
          }.bind(this)
        )
        .catch((reason) => {
          console.log(reason);
        });
    },
    onChangePurchase(val) {
      this.purchaseType = val.target.value;
      this.purchaseHandle(this.purchaseType);
    },
    purchaseHandle(val) {
      if (val === "a") {
        AreaLineChart(
          "PurchaseTimePreference",
          this.purchasePreferenceData.purchaseTypeCycle
        );
      } else {
        AreaLineChart(
          "PurchaseTimePreference",
          this.purchasePreferenceData.purchaseTypeCyclePoint
        );
      }
    },
    showThousandNumber(value) {
      return util.showThousandNumber(value);
    },
    //数组反转
    reversal(arr) {
      var arr1 = [];
      for (var i = arr.length - 1; i >= 0; i--) {
        arr1.push(arr[i]);
      }
      return arr1;
    },
    sortData(data) {
      let dataArr = [];
      let dataObj = [];
      let legend = [];
      data.forEach((ele) => {
        for (let key in ele) {
          dataArr.push({ name: key, num: ele[key] });
        }
      });
      dataArr.sort((a, b) => a.num - b.num);
      dataArr.forEach((item) => {
        let a = {};
        a[item.name] = item.num;
        dataObj.push(a);
        legend.push(item.name);
      });
      let new_data = { data: dataObj, legend };
      return new_data;
    },
    peopleChgAdd(val) {
      if (this.tabSelected === "group_tab2") {
        this.purchaseType = "a";
      }
      this.$forceUpdate();
      this.queryCharsById(val);
    },
    forceUpdate() {
      this.$forceUpdate();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>
<style lang="less" scoped>
.mb20 {
  margin-bottom: 20px;
}
.mb30 {
  margin-bottom: 30px;
}
.mr14 {
  margin-right: 14px;
}
.ml14 {
  margin-left: 14px;
}
.ml7 {
  margin-left: 7px;
}
.mr7 {
  margin-right: 7px;
}
.ml18 {
  margin-left: 18px;
}
.mr18 {
  margin-right: 18px;
}
.height200 {
  height: 200px;
}
.height220 {
  height: 220px;
}
.height260 {
  height: 260px;
}
.height300 {
  height: 300px;
}
.height320 {
  height: 320px;
}
.card-container {
  margin-top: 10px;
  padding-bottom: 40px;
}
.member-container {
  width: 92%;
  border-radius: 8px;
  // background: linear-gradient(180deg, #FFA600 0%, #FBBE02 100%);
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  .icon-container {
    width: 56px;
    height: 56px;
    background-color: #ffffff;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .num-container {
    padding-left: 16px;
    .num {
      display: flex;
      align-items: baseline;
    }
    .title {
      color: #ffffff;
    }
  }
}
.border-container {
  border: 1px solid #e1e4e8;
  border-radius: 4px;
  padding: 14px;
  box-sizing: border-box;

  .common-title {
    color: #000000;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    .ant-radio-group {
      font-weight: normal;
    }
    // .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    //   background-color: #FBBE02;
    // }
    // .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
    //   color: #ffffff;
    //   background: #FBBE02;
    //   border-color: #FBBE02;
    // }
    .statistics-container {
      color: var(--font-color);
      background: var(--main-color);
      border-radius: 4px;
      padding: 0 6px;
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-bottom: 2px;
      .statistics-num {
        font-size: 14px;
        font-weight: bold;
      }
      .statistics-title {
        font-size: 12px;
      }
    }
  }
  .city-title {
    font-size: 12px;
    color: #000000;
    margin-top: -2px;
    padding-bottom: 2px;
  }
  .city-divider-container {
    background: #f1f2f4 !important;
    margin-top: 0px !important;
    margin-bottom: 20px !important;
  }
  .divider-container-nobottom {
    background: #f1f2f4 !important;
    margin-top: 16px !important;
    margin-bottom: 4px !important;
  }
  .divider-container {
    background: #f1f2f4 !important;
    margin-top: 16px !important;
    margin-bottom: 20px !important;
  }
}
</style>
